/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface ExportBillingSummaryRequest {
    periodStart?: Date;
    periodEnd?: Date;
    refresh?: boolean;
}

export interface GetBillingSummaryRequest {
    periodStart?: Date;
    periodEnd?: Date;
    refresh?: boolean;
}

export interface GetIntegrationQuotaRequest {
    featureId?: string;
    metricName?: string;
}

export interface GetIntegrationSloRequest {
    periodStart?: Date;
    periodEnd?: Date;
}

export interface GetUsageByInstanceRequest {
    periodType?: string;
    periodValue?: number;
    startDate?: Date;
    endDate?: Date;
}

export interface GetUsageSummaryRequest {
    periodType?: string;
    periodValue?: number;
    startDate?: Date;
    endDate?: Date;
}

/**
 * IntegrationUsageApi - interface
 * 
 * @export
 * @interface IntegrationUsageApiInterface
 */
export interface IntegrationUsageApiInterface {
    /**
     * Downloads tenant- and instance-level metrics for the billing period as CSV.
     * @summary Export billing-period usage summary as CSV
     * @param {Date} [periodStart] 
     * @param {Date} [periodEnd] 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationUsageApiInterface
     */
    exportBillingSummaryRaw(requestParameters: ExportBillingSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Downloads tenant- and instance-level metrics for the billing period as CSV.
     * Export billing-period usage summary as CSV
     */
    exportBillingSummary(requestParameters: ExportBillingSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Returns pre-aggregated usage for a billing period (defaults to current calendar month). Set refresh=true to run batch aggregation before reading.
     * @summary Get billing-period usage summary
     * @param {Date} [periodStart] Billing period start (defaults to first day of current month)
     * @param {Date} [periodEnd] Billing period end (defaults to today)
     * @param {boolean} [refresh] Run batch aggregation for this period before returning results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationUsageApiInterface
     */
    getBillingSummaryRaw(requestParameters: GetBillingSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns pre-aggregated usage for a billing period (defaults to current calendar month). Set refresh=true to run batch aggregation before reading.
     * Get billing-period usage summary
     */
    getBillingSummary(requestParameters: GetBillingSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns metered quota status (execution_count vs entitlement limit) for each selected tenant in the current calendar month.
     * @summary Get integration execution quota for selected tenants
     * @param {string} [featureId] Feature ID (defaults to integration_execution)
     * @param {string} [metricName] Metric name (defaults to execution_count)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationUsageApiInterface
     */
    getIntegrationQuotaRaw(requestParameters: GetIntegrationQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns metered quota status (execution_count vs entitlement limit) for each selected tenant in the current calendar month.
     * Get integration execution quota for selected tenants
     */
    getIntegrationQuota(requestParameters: GetIntegrationQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns SLO compliance for selected tenants over a rolling lookback window (fetch p95 latency, execution p95 latency, success rate / error budget).
     * @summary Get integration SLO dashboard
     * @param {Date} [periodStart] Period start (ISO-8601 instant). Defaults to lookback window.
     * @param {Date} [periodEnd] Period end (ISO-8601 instant). Defaults to now.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationUsageApiInterface
     */
    getIntegrationSloRaw(requestParameters: GetIntegrationSloRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns SLO compliance for selected tenants over a rolling lookback window (fetch p95 latency, execution p95 latency, success rate / error budget).
     * Get integration SLO dashboard
     */
    getIntegrationSlo(requestParameters: GetIntegrationSloRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns PENDING + PROCESSING chunk counts per pipeline stage for selected tenants, compared to configurable depth limits (INTEGRATION_RUNTIME with property fallbacks).
     * @summary Get pipeline queue depth alarms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationUsageApiInterface
     */
    getQueueDepthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns PENDING + PROCESSING chunk counts per pipeline stage for selected tenants, compared to configurable depth limits (INTEGRATION_RUNTIME with property fallbacks).
     * Get pipeline queue depth alarms
     */
    getQueueDepth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns optional per-tenant daily cap from tenant_entitlement.metadata.max_triggers_per_day and intent counts for the current UTC day.
     * @summary Get daily trigger intent quota for selected tenants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationUsageApiInterface
     */
    getTriggerDailyQuotaRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns optional per-tenant daily cap from tenant_entitlement.metadata.max_triggers_per_day and intent counts for the current UTC day.
     * Get daily trigger intent quota for selected tenants
     */
    getTriggerDailyQuota(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns detailed usage statistics broken down by integration instance across all selected tenants. Supports filtering by reporting period or date range.
     * @summary Get usage by instance for selected tenants
     * @param {string} [periodType] Reporting period type (MINUTES, HOURS, DAYS, MONTHS, QUARTERS, ALL_TIME)
     * @param {number} [periodValue] Reporting period value (e.g., 7 for \&#39;Last 7 days\&#39;)
     * @param {Date} [startDate] Start date (ISO-8601 format). Alternative to reporting period.
     * @param {Date} [endDate] End date (ISO-8601 format). Defaults to now if not provided.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationUsageApiInterface
     */
    getUsageByInstanceRaw(requestParameters: GetUsageByInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns detailed usage statistics broken down by integration instance across all selected tenants. Supports filtering by reporting period or date range.
     * Get usage by instance for selected tenants
     */
    getUsageByInstance(requestParameters: GetUsageByInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns aggregated usage statistics across all integration instances for all selected tenants. Supports filtering by reporting period or date range.
     * @summary Get usage summary for selected tenants
     * @param {string} [periodType] Reporting period type (MINUTES, HOURS, DAYS, MONTHS, QUARTERS, ALL_TIME)
     * @param {number} [periodValue] Reporting period value (e.g., 7 for \&#39;Last 7 days\&#39;)
     * @param {Date} [startDate] Start date (ISO-8601 format). Alternative to reporting period.
     * @param {Date} [endDate] End date (ISO-8601 format). Defaults to now if not provided.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationUsageApiInterface
     */
    getUsageSummaryRaw(requestParameters: GetUsageSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns aggregated usage statistics across all integration instances for all selected tenants. Supports filtering by reporting period or date range.
     * Get usage summary for selected tenants
     */
    getUsageSummary(requestParameters: GetUsageSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationUsageApi extends runtime.BaseAPI implements IntegrationUsageApiInterface {

    /**
     * Downloads tenant- and instance-level metrics for the billing period as CSV.
     * Export billing-period usage summary as CSV
     */
    async exportBillingSummaryRaw(requestParameters: ExportBillingSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['periodStart'] != null) {
            queryParameters['periodStart'] = (requestParameters['periodStart'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['periodEnd'] != null) {
            queryParameters['periodEnd'] = (requestParameters['periodEnd'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/usage/billing-summary/export`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Downloads tenant- and instance-level metrics for the billing period as CSV.
     * Export billing-period usage summary as CSV
     */
    async exportBillingSummary(requestParameters: ExportBillingSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exportBillingSummaryRaw(requestParameters, initOverrides);
    }

    /**
     * Returns pre-aggregated usage for a billing period (defaults to current calendar month). Set refresh=true to run batch aggregation before reading.
     * Get billing-period usage summary
     */
    async getBillingSummaryRaw(requestParameters: GetBillingSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['periodStart'] != null) {
            queryParameters['periodStart'] = (requestParameters['periodStart'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['periodEnd'] != null) {
            queryParameters['periodEnd'] = (requestParameters['periodEnd'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/usage/billing-summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns pre-aggregated usage for a billing period (defaults to current calendar month). Set refresh=true to run batch aggregation before reading.
     * Get billing-period usage summary
     */
    async getBillingSummary(requestParameters: GetBillingSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBillingSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns metered quota status (execution_count vs entitlement limit) for each selected tenant in the current calendar month.
     * Get integration execution quota for selected tenants
     */
    async getIntegrationQuotaRaw(requestParameters: GetIntegrationQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['featureId'] != null) {
            queryParameters['featureId'] = requestParameters['featureId'];
        }

        if (requestParameters['metricName'] != null) {
            queryParameters['metricName'] = requestParameters['metricName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/usage/quota`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns metered quota status (execution_count vs entitlement limit) for each selected tenant in the current calendar month.
     * Get integration execution quota for selected tenants
     */
    async getIntegrationQuota(requestParameters: GetIntegrationQuotaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getIntegrationQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns SLO compliance for selected tenants over a rolling lookback window (fetch p95 latency, execution p95 latency, success rate / error budget).
     * Get integration SLO dashboard
     */
    async getIntegrationSloRaw(requestParameters: GetIntegrationSloRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['periodStart'] != null) {
            queryParameters['periodStart'] = (requestParameters['periodStart'] as any).toISOString();
        }

        if (requestParameters['periodEnd'] != null) {
            queryParameters['periodEnd'] = (requestParameters['periodEnd'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/usage/slo`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns SLO compliance for selected tenants over a rolling lookback window (fetch p95 latency, execution p95 latency, success rate / error budget).
     * Get integration SLO dashboard
     */
    async getIntegrationSlo(requestParameters: GetIntegrationSloRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getIntegrationSloRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns PENDING + PROCESSING chunk counts per pipeline stage for selected tenants, compared to configurable depth limits (INTEGRATION_RUNTIME with property fallbacks).
     * Get pipeline queue depth alarms
     */
    async getQueueDepthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/usage/queue-depth`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns PENDING + PROCESSING chunk counts per pipeline stage for selected tenants, compared to configurable depth limits (INTEGRATION_RUNTIME with property fallbacks).
     * Get pipeline queue depth alarms
     */
    async getQueueDepth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getQueueDepthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns optional per-tenant daily cap from tenant_entitlement.metadata.max_triggers_per_day and intent counts for the current UTC day.
     * Get daily trigger intent quota for selected tenants
     */
    async getTriggerDailyQuotaRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/usage/trigger-quota`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns optional per-tenant daily cap from tenant_entitlement.metadata.max_triggers_per_day and intent counts for the current UTC day.
     * Get daily trigger intent quota for selected tenants
     */
    async getTriggerDailyQuota(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTriggerDailyQuotaRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns detailed usage statistics broken down by integration instance across all selected tenants. Supports filtering by reporting period or date range.
     * Get usage by instance for selected tenants
     */
    async getUsageByInstanceRaw(requestParameters: GetUsageByInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['periodType'] != null) {
            queryParameters['periodType'] = requestParameters['periodType'];
        }

        if (requestParameters['periodValue'] != null) {
            queryParameters['periodValue'] = requestParameters['periodValue'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/usage/by-instance`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns detailed usage statistics broken down by integration instance across all selected tenants. Supports filtering by reporting period or date range.
     * Get usage by instance for selected tenants
     */
    async getUsageByInstance(requestParameters: GetUsageByInstanceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUsageByInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns aggregated usage statistics across all integration instances for all selected tenants. Supports filtering by reporting period or date range.
     * Get usage summary for selected tenants
     */
    async getUsageSummaryRaw(requestParameters: GetUsageSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['periodType'] != null) {
            queryParameters['periodType'] = requestParameters['periodType'];
        }

        if (requestParameters['periodValue'] != null) {
            queryParameters['periodValue'] = requestParameters['periodValue'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integration/usage/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns aggregated usage statistics across all integration instances for all selected tenants. Supports filtering by reporting period or date range.
     * Get usage summary for selected tenants
     */
    async getUsageSummary(requestParameters: GetUsageSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUsageSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
